var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invoice-bill-svgrepo-com (2) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.68116 8.00001C3.88153 8.00001 4.04396 7.83758 4.04396 7.63721C4.04396 7.43685 3.88153 7.27441 3.68116 7.27441C3.48079 7.27441 3.31836 7.43685 3.31836 7.63721C3.31836 7.83758 3.48079 8.00001 3.68116 8.00001Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.398 1.64436C13.311 1.58632 13.1948 1.58632 13.1078 1.64436L12.3822 2.13779L11.6855 1.6734C11.5985 1.61535 11.4533 1.61535 11.3663 1.6734L10.6406 2.13779L9.94405 1.6734C9.85698 1.61535 9.71186 1.61535 9.62478 1.6734L8.89915 2.13779L8.20256 1.6734C8.11549 1.61535 7.97037 1.61535 7.88329 1.6734L7.15766 2.13779L6.46107 1.6734C6.374 1.61535 6.22888 1.61535 6.1418 1.6734L5.41617 2.13779L4.71956 1.6734C4.63248 1.61535 4.48736 1.61535 4.40028 1.6734L3.67468 2.13779L2.97807 1.6734C2.89099 1.61535 2.7749 1.61535 2.68783 1.6734C2.57171 1.70243 2.51367 1.78951 2.51367 1.90559V14.0961C2.51367 14.2122 2.57171 14.2992 2.65879 14.3573C2.74587 14.4153 2.86196 14.4153 2.94903 14.3573L3.67466 13.8639L4.37125 14.3282C4.45833 14.3863 4.60345 14.3863 4.69052 14.3282L5.38711 13.8639L6.08371 14.3282C6.17078 14.3863 6.3159 14.3863 6.40298 14.3282L7.09957 13.8639L7.79616 14.3282C7.88324 14.3863 8.02836 14.3863 8.11544 14.3282L8.81203 13.8639L9.50862 14.3282C9.5957 14.3863 9.74082 14.3863 9.82789 14.3282L10.5245 13.8639L11.2211 14.3282C11.3082 14.3863 11.4533 14.3863 11.5403 14.3282L12.2369 13.8639L12.9335 14.3282C12.9916 14.3573 13.0496 14.3863 13.1077 14.3863C13.1657 14.3863 13.1948 14.3863 13.2528 14.3573C13.3399 14.2992 13.3979 14.2121 13.3979 14.096V1.90559C13.5431 1.78951 13.4851 1.70243 13.398 1.64436ZM12.5563 13.2543C12.4692 13.1963 12.3241 13.1963 12.237 13.2543L11.5114 13.7478L10.8148 13.2834C10.7568 13.2543 10.6987 13.2253 10.6406 13.2253C10.5826 13.2253 10.5245 13.2544 10.4665 13.2834L9.7699 13.7478L9.07331 13.2834C8.98623 13.2253 8.84111 13.2253 8.75403 13.2834L8.02841 13.7478L7.33182 13.2834C7.24474 13.2253 7.09962 13.2253 7.01254 13.2834L6.28692 13.7478L5.59033 13.2834C5.50325 13.2253 5.35813 13.2253 5.27105 13.2834L4.54543 13.7478L3.84884 13.2834C3.76176 13.2253 3.61664 13.2253 3.52956 13.2834L3.12319 13.5736V2.45706L3.52954 2.7473C3.61661 2.80535 3.76173 2.80535 3.84881 2.7473L4.5454 2.25388L5.24202 2.7183C5.3291 2.77634 5.47422 2.77634 5.56129 2.7183L6.28692 2.2539L6.98351 2.7183C7.07059 2.77634 7.21571 2.77634 7.30278 2.7183L8.02841 2.2539L8.725 2.7183C8.81208 2.77634 8.9572 2.77634 9.04428 2.7183L9.7699 2.2539L10.4665 2.7183C10.5536 2.77634 10.6987 2.77634 10.7858 2.7183L11.5114 2.2539L12.208 2.7183C12.2951 2.77634 12.4402 2.77634 12.5273 2.7183L12.9336 2.42806V13.5239L12.5563 13.2543Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.6636 9.45122H10.938C10.7203 9.45122 10.5752 9.30608 10.5752 9.08841C10.5752 8.87075 10.7203 8.72562 10.938 8.72562H12.0264C12.2441 8.72562 12.3892 8.58048 12.3892 8.36281C12.3892 8.14515 12.2441 8.00001 12.0264 8.00001H11.6636V7.63721C11.6636 7.41952 11.5185 7.27441 11.3008 7.27441C11.0832 7.27441 10.938 7.41955 10.938 7.63721V8.00001C10.3213 8.00001 9.84961 8.47166 9.84961 9.08845C9.84961 9.70523 10.3213 10.1769 10.938 10.1769H11.6637C11.8814 10.1769 12.0265 10.322 12.0265 10.5397C12.0265 10.7574 11.8813 10.9025 11.6637 10.9025H10.5752C10.3575 10.9025 10.2124 11.0476 10.2124 11.2653C10.2124 11.4829 10.3576 11.6281 10.5752 11.6281H10.938V11.9909C10.938 12.2086 11.0832 12.3537 11.3008 12.3537C11.5185 12.3537 11.6636 12.2085 11.6636 11.9909V11.6281C12.2804 11.6281 12.7521 11.1564 12.7521 10.5396C12.7521 9.92289 12.2804 9.45122 11.6636 9.45122Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.9373 3.28345H5.13233C4.91464 3.28345 4.76953 3.42859 4.76953 3.64625C4.76953 3.86391 4.91467 4.00905 5.13233 4.00905H10.9373C11.155 4.00905 11.3001 3.86391 11.3001 3.64625C11.3001 3.42859 11.155 3.28345 10.9373 3.28345Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.486 4.73462H6.5835C6.36581 4.73462 6.2207 4.87976 6.2207 5.09742C6.2207 5.31511 6.36584 5.46022 6.5835 5.46022H9.486C9.70369 5.46022 9.8488 5.31508 9.8488 5.09742C9.84883 4.87973 9.70369 4.73462 9.486 4.73462Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.94639 7.27441H5.13233C4.91464 7.27441 4.76953 7.41955 4.76953 7.63721C4.76953 7.85488 4.91467 8.00001 5.13233 8.00001H6.94639C7.16409 8.00001 7.30919 7.85488 7.30919 7.63721C7.30919 7.41955 7.16409 7.27441 6.94639 7.27441Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M3.68116 9.45119C3.88153 9.45119 4.04396 9.28875 4.04396 9.08839C4.04396 8.88802 3.88153 8.72559 3.68116 8.72559C3.48079 8.72559 3.31836 8.88802 3.31836 9.08839C3.31836 9.28875 3.48079 9.45119 3.68116 9.45119Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M7.30919 8.72559H5.13233C4.91464 8.72559 4.76953 8.87072 4.76953 9.08839C4.76953 9.30605 4.91467 9.45119 5.13233 9.45119H7.30919C7.52689 9.45119 7.67199 9.30605 7.67199 9.08839C7.67199 8.87072 7.52689 8.72559 7.30919 8.72559Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M3.68116 10.9024C3.88153 10.9024 4.04396 10.7399 4.04396 10.5396C4.04396 10.3392 3.88153 10.1768 3.68116 10.1768C3.48079 10.1768 3.31836 10.3392 3.31836 10.5396C3.31836 10.7399 3.48079 10.9024 3.68116 10.9024Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M6.58356 10.1768H5.13233C4.91464 10.1768 4.76953 10.3219 4.76953 10.5396C4.76953 10.7573 4.91467 10.9024 5.13233 10.9024H6.58356C6.80126 10.9024 6.94636 10.7572 6.94636 10.5396C6.94636 10.3219 6.80122 10.1768 6.58356 10.1768Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M3.68116 12.3538C3.88153 12.3538 4.04396 12.1913 4.04396 11.991C4.04396 11.7906 3.88153 11.6282 3.68116 11.6282C3.48079 11.6282 3.31836 11.7906 3.31836 11.991C3.31836 12.1913 3.48079 12.3538 3.68116 12.3538Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M8.03483 11.6282H5.13233C4.91464 11.6282 4.76953 11.7733 4.76953 11.991C4.76953 12.2086 4.91467 12.3538 5.13233 12.3538H8.03483C8.25252 12.3538 8.39763 12.2086 8.39763 11.991C8.39763 11.7733 8.25252 11.6282 8.03483 11.6282Z",
    fill: "black"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoice-icon.aef6c6721c62da5842814ffcc9d92c6b.svg";
export { ForwardRef as ReactComponent };